import React from "react";
import PropTypes from "prop-types";
import { ProgramItem } from "./ProgramItem";
import { Link } from "react-router-dom";
import {
  selectCity,
  fetchMoviesFromFestivalIfNeeded,
  selectDay,
  fetchMoviesFromFestivalDay,
  months
} from "../../actions";

import MotionScroll from "../HomeView/MotionScroll";

export class ProgramView extends React.Component {
  constructor(props) {
    super(props);
    this.clickArrow = this.clickArrow.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.current_events_page = 0;
    this.maxpages_events = 0;
    this.current_days_page = 0;
    this.maxpages_days = 0;
    this.arrowOffset = 230;
    this.dayWW = 70;

    this.program_items = null;
    this.days_container = null;

    this.state = {
      spos: 0,
      dayPos: 0
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, city_movies, selectedDay } = nextProps;
    const num_days = (typeof city_movies === 'undefined') ? 0 : Object.keys(city_movies).length;

    if (selectedDay === "0" && num_days > 0) {
      dispatch(selectDay(Object.keys(city_movies)[0] + ""));
    }

    if (window.innerWidth < 550) {
      this.arrowOffset = 10;
    }

    this.maxpages_events = 0;
    this.current_events_page = 0;
    this.current_days_page = 0;
    this.maxpages_days = 0;

    if (typeof city_movies !== "undefined" && typeof city_movies[selectedDay] !== "undefined") {
      // colocar isto dinamico
      if (window.innerWidth > 988) {
        this.maxpages_events = Math.ceil(city_movies[selectedDay].length / 4);
      } else {
        this.maxpages_events = city_movies[selectedDay].length;
      }

      setTimeout(() => {
        this.toggleArrows(
          this.maxpages_events,
          this.current_events_page,
          "left_arrow_events_ico",
          "right_arrow_events_ico"
        );
      }, 0);

      //var jqEl = $(this.refs.program_items)
      //jqEl.animate({scrollLeft: 0})

      this.setState({
        spos: 0
      });

      setTimeout(() => {
        const numdays = (typeof city_movies === 'undefined') ? 0 : Object.keys(city_movies).length;
        
        if (this.refs.days_container) {
          const containerWW = this.refs.days_container.clientWidth;
          const totalWW = numdays * this.dayWW;

          if (totalWW < containerWW) {
            this.maxpages_days = 0;
          } else {
            this.maxpages_days = Math.ceil(numdays * this.dayWW / containerWW);
          }

          this.toggleArrows(
            this.maxpages_days,
            this.current_days_page,
            "left_arrow_days_ico",
            "right_arrow_days_ico"
          );

          this.refs.days_container.style.marginLeft = "0";
        }
      }, 500);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.handleEscapeKey);
  }

  handleResize() {
    const { city_movies, selectedDay } = this.props;
    if (typeof city_movies[selectedDay] !== "undefined") {
      // colocar isto dinamico
      if (window.innerWidth > 988) {
        this.maxpages_events = Math.ceil(city_movies[selectedDay].length / 4);
      } else {
        this.maxpages_events = city_movies[selectedDay].length;
      }

      this.toggleArrows(
        this.maxpages_events,
        this.current_events_page,
        "left_arrow_events_ico",
        "right_arrow_events_ico"
      );
    }

    const numdays = Object.keys(this.props.city_movies).length;
    if (this.refs.days_container) {
      const containerWW = this.refs.days_container.clientWidth;
      const totalWW = numdays * this.dayWW;

      if (totalWW < containerWW) {
        this.maxpages_days = 0;
      } else {
        this.maxpages_days = Math.ceil(numdays * this.dayWW / containerWW);
      }

      this.toggleArrows(
        this.maxpages_days,
        this.current_days_page,
        "left_arrow_days_ico",
        "right_arrow_days_ico"
      );

      this.refs.days_container.style.marginLeft = "0";
      this.refs.days_container.style.scrollLeft = 0;
    }
  }

  toggleArrows(maxpages, curpage, leftArrow, rightArrow) {
    if (
      typeof this.refs[leftArrow] === "undefined" ||
      typeof this.refs[rightArrow] === "undefined"
    ) {
      return;
    }

    if (maxpages > 1 && curpage < maxpages - 1) {
      this.refs[rightArrow].classList.remove("hide");
    } else {
      this.refs[rightArrow].classList.add("hide");
    }

    if (parseInt(curpage, 10) !== 0) {
      this.refs[leftArrow].classList.remove("hide");
    } else {
      this.refs[leftArrow].classList.add("hide");
    }

    if (maxpages === 0) {
      this.refs[leftArrow].classList.add("hide");
      this.refs[rightArrow].classList.add("hide");
    }
  }

  clickArrow(direction, type) {
    let cur_page = 0;
    let el;
    if (type === "events") {
      cur_page = this.current_events_page;
      el = this.program_items;
    } else {
      cur_page = this.current_days_page;
      el = this.days_container;
    }

    if (direction === "right") {
      cur_page++;
    } else {
      cur_page--;
      if (cur_page < 0) {
        cur_page = 0;
      }
    }

    //var jqEl = $(el)
    if (type === "events") {
      this.current_events_page = cur_page;
      // let goXX = this.current_events_page * (el.clientWidth - this.arrowOffset)
      let goXX = this.current_events_page * el.clientWidth;
      if (goXX < 0) {
        goXX = 0;
      }
      this.toggleArrows(
        this.maxpages_events,
        this.current_events_page,
        "left_arrow_events_ico",
        "right_arrow_events_ico"
      );
      //jqEl.animate({scrollLeft: goXX})

      this.setState({
        spos: goXX
      });
    } else {
      this.current_days_page = cur_page;
      // let goXX = (this.current_days_page * (el.clientWidth - this.arrowOffset))
      let goXX = this.current_days_page * el.clientWidth;
      if (goXX < 0) {
        goXX = 0;
      }
      this.toggleArrows(
        this.maxpages_days,
        this.current_days_page,
        "left_arrow_days_ico",
        "right_arrow_days_ico"
      );

      //jqEl.animate({scrollLeft: goXX})
      this.setState({
        dayPos: goXX
      });
    }

    setTimeout(function() {
      window.dispatchEvent(new Event("resize"));
    }, 400);
  }

  getPageUrl(id, ismovie) {
    if (ismovie === "1") {
      return `/filme/${id}`;
    } else {
      return `/actividade/${id}`;
    }
  }

  renderMoviesFromDay(movie_list) {
    if (typeof movie_list === "undefined") {
      return;
    }

    return movie_list.map((movie, i) => {
      return (
        <Link key={i} to={this.getPageUrl(movie.id, movie.ismovie)}>
          <ProgramItem key={`p${i}`} movie={movie} />
        </Link>
      );
    });
  }

  onCityClicked(city_id) {
    this.props.dispatch(selectCity(city_id + ""));
    this.props.dispatch(selectDay("0"));
    this.props.dispatch(fetchMoviesFromFestivalIfNeeded(city_id + ""));
  }

  onDayClicked(day, month) {
    const mm = months[parseInt(month, 10)].toUpperCase();
    if (this.props.selectedDay !== day) {
      /*
      const d = parseInt(day.substr(1), 10)
      if (d < 27) {
        this.refs.monthEl.innerHTML = 'ABRIL'
      } else {
        this.refs.monthEl.innerHTML = 'MARÇO'
      }
      */
      this.refs.monthEl.innerHTML = mm;
      this.props.dispatch(selectDay(day + ""));
      this.props.dispatch(fetchMoviesFromFestivalDay());
    }
  }

  renderDays(city_movies) {
    return Object.keys(city_movies).map((day, i) => {
      const mm = city_movies[day].length ? city_movies[day][0].mm : "09";
      var boundClick = this.onDayClicked.bind(this, day, mm);
      const d = day.substr(1);
      if (day === this.props.selectedDay) {
        return (
          <div key={`x${i}`} className="day-box">
            <p
              key={i}
              style={{ color: this.props.selectedAgendaColor }}
              className="active"
              onClick={boundClick}
            >
              {d}
            </p>
          </div>
        );
      } else {
        return (
          <div key={`s${i}`} className="day-box">
            <p key={i} onClick={boundClick}>
              {d}
            </p>
          </div>
        );
      }
    });
  }

  renderCities(city_list) {
    return city_list.map((city, i) => {
      var boundClick = this.onCityClicked.bind(this, city.id);
      
      if (this.props.selectedCity === "-1" && i === 0) {
        return (
          <li key={i} className="active" onClick={boundClick}>
            {city.name}
          </li>
        );
      } else if (city.id + "" === this.props.selectedCity) {
        return (
          <li key={i} className="active" onClick={boundClick}>
            {city.name}
          </li>
        );
      } else {
        return (
          <li key={i} onClick={boundClick}>
            {city.name}
          </li>
        );
      }
    });
  }

  render() {
    const {
      city_movies,
      cities,
      selectedDay,
      selectedCity,
      selectedAgendaColor,
      isFetchingMovieCity
    } = this.props;

    if (selectedCity === "-1" && cities.length) {
      this.onCityClicked(cities[0].id + "");
      return (
        <div id="program-view" className="row">
          <p className="section-title">PROGRAMAÇÃO</p>
          <div
            className="col-md-2 locals"
            style={{ backgroundColor: selectedAgendaColor }}
          >
            <ul>{this.renderCities(cities)}</ul>
          </div>
          <div className="col-md-10">
            <h4>A OBTER LISTA DE EVENTOS</h4>
          </div>
        </div>
      );
    }

    if (isFetchingMovieCity) {
      return (
        <div id="program-view" className="row">
          <p className="section-title">PROGRAMAÇÃO</p>
          <div
            className="col-md-2 locals"
            style={{ backgroundColor: selectedAgendaColor }}
          >
            <ul>{this.renderCities(cities)}</ul>
          </div>
          <div className="col-md-10">
            <h4>A OBTER LISTA DE EVENTOS</h4>
          </div>
        </div>
      );
    }

    if (
      typeof city_movies[selectedDay] === "undefined" ||
      !city_movies[selectedDay].length
    ) {
      const msg = (this.props.numPastEvents === 0) ? "A ANUNCIAR BREVEMENTE" : "EVENTO TERMINADO";
      return (
        <div id="program-view" className="row">
          <p className="section-title">PROGRAMAÇÃO</p>
          <div
            className="col-md-2 locals"
            style={{ backgroundColor: selectedAgendaColor }}
          >
            <ul>{this.renderCities(cities)}</ul>
          </div>
          <div className="col-md-10">
            <h4>{msg}</h4>
          </div>
        </div>
      );
    }

    let firstDayInfo = city_movies[Object.keys(city_movies)[0]];

    let firstmonth = "---";
    if (firstDayInfo.length) {
      firstmonth = months[parseInt(firstDayInfo[0].mm, 10)].toUpperCase();
    }

    var leftArrowClickEvents = this.clickArrow.bind(this, "left", "events");
    var rightArrowClickEvents = this.clickArrow.bind(this, "right", "events");
    var leftArrowDayClickEvents = this.clickArrow.bind(this, "left", "days");
    var rightArrowDayClickEvents = this.clickArrow.bind(this, "right", "days");

    return (
      <div id="program-view" className="row">
        <p className="section-title">PROGRAMAÇÃO</p>
        <div
          className="col-md-2 locals"
          style={{ backgroundColor: selectedAgendaColor }}
        >
          <ul>{this.renderCities(cities)}</ul>
        </div>
        <div className="col-md-10 col-md-10 calendar">
          <div className="row">
            <div
              className="col-xs-1 col-md-1 no-pad-right text-center day-nav-arrow"
              onClick={leftArrowDayClickEvents}
            >
              <span
                ref="left_arrow_days_ico"
                className="arrow glyphicon glyphicon-chevron-left"
                aria-hidden="true"
              />
            </div>
            <div
              id="days_list"
              ref="days_list"
              className="col-xs-10 col-md-10 no-pad"
            >
              <div className="col-xs-4 col-md-5 col-md-2 month">
                <p ref="monthEl">{firstmonth}</p>
              </div>

              <div className="col-xs-8 col-sm-7 col-md-10 days no-pad">
                <div
                  ref={d => (this.days_container = d)}
                  id="days_container"
                  className="nowrap"
                >
                  {this.renderDays(city_movies)}
                </div>
              </div>

              <MotionScroll
                scrollLeft={this.state.dayPos}
                el={this.days_container}
              />
            </div>
            <div
              className="col-xs-1 col-md-1 no-pad-left text-center day-nav-arrow"
              onClick={rightArrowDayClickEvents}
            >
              <span
                ref="right_arrow_days_ico"
                className="arrow glyphicon glyphicon-chevron-right"
                aria-hidden="true"
              />
            </div>
          </div>

          <div className="row">
            <div
              className="col-xs-1 no-pad-right text-center evt-nav-arrow"
              onClick={leftArrowClickEvents}
            >
              <span
                ref="left_arrow_events_ico"
                className="arrow glyphicon glyphicon-chevron-left"
                aria-hidden="true"
              />
            </div>

            <div
              id="program_items"
              ref={p => (this.program_items = p)}
              className="col-xs-10 no-pad nowrap"
            >
              {this.renderMoviesFromDay(city_movies[selectedDay])}
            </div>

            <MotionScroll
              scrollLeft={this.state.spos}
              el={this.program_items}
            />

            <div
              className="col-xs-1 no-pad-left text-center evt-nav-arrow"
              onClick={rightArrowClickEvents}
            >
              <span
                ref="right_arrow_events_ico"
                className="arrow glyphicon glyphicon-chevron-right"
                aria-hidden="true"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProgramView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isFetchingMovieCity: PropTypes.bool.isRequired,
  selectedCity: PropTypes.string.isRequired,
  selectedDay: PropTypes.string.isRequired,
  city_movies: PropTypes.object.isRequired,
  cities: PropTypes.array.isRequired,
  selectedAgendaColor: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/views/ProgramView/ProgramView.js